import { useEffect, useState } from 'react';
import { MAX_TIME_LEFT_TIMEOUT_MODAL, SESSION_STATUS } from 'components/sessionTimeOut/constants';

export const useTimeOutModalCheck = ({ session, modalCancelActions }) => {
    const [{ showTimeoutModal, timeOutBlowupClass }, setTimeoutModalConfig] = useState(false);

    const openTimeOutModal = () => {
        modalCancelActions.hideModalCancel();

        setTimeoutModalConfig(prevState => ({
            ...prevState,
            showTimeoutModal: true,
            timeOutBlowupClass: 'blowup-modal blowup-in',
        }));
    };
    const closeTimeOutModal = () => {
        setTimeoutModalConfig(prevState => ({ ...prevState, timeOutBlowupClass: 'blowup-modal blowup-out' }));

        setTimeout(() => {
            setTimeoutModalConfig(prevState => ({ ...prevState, showTimeoutModal: false }));
        }, 200);
    };
    const checkTimeoutModalCondition = () => {
        const sessionStatus = session.get('sessionStatus');
        const minLeft = sessionStatus.get('minLeft');
        const status = sessionStatus.get('status');
        const renewals = sessionStatus.get('renewals');
        const closed = sessionStatus.get('closed');

        const isCountDownAllowed = status === SESSION_STATUS.OK && renewals < 1 && !closed;
        const isTimeLeftUnderLimit = minLeft < MAX_TIME_LEFT_TIMEOUT_MODAL;

        isCountDownAllowed && isTimeLeftUnderLimit && !showTimeoutModal && openTimeOutModal();
    };

    useEffect(() => {
        checkTimeoutModalCondition();
    }, [session]);

    return { showTimeoutModal, timeOutBlowupClass, openTimeOutModal, closeTimeOutModal };
};
